import { Copy, MoreHorizontal, Printer } from "lucide-react";
import { Button } from "@akuna/ui";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface MobileViewOverflowMenuProps {
  moreLabel: string;
  copyLabel: string;
  exportLabel: string;
  onCopy: () => void;
  onExport: () => void;
}

export function MobileViewOverflowMenu({
  moreLabel,
  copyLabel,
  exportLabel,
  onCopy,
  onExport,
}: MobileViewOverflowMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="h-[38px] w-[38px] rounded-full border border-border/60 bg-card shadow-sm" aria-label={moreLabel}>
          <MoreHorizontal className="h-[18px] w-[18px]" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onSelect={onCopy}><Copy className="mr-2 h-4 w-4" />{copyLabel}</DropdownMenuItem>
        <DropdownMenuItem onSelect={onExport}><Printer className="mr-2 h-4 w-4" />{exportLabel}</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
